import * as React from 'react'
import moment from 'moment'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'

interface Props {
  inventoryLogs: IInventoryLog[]
}

export class InventoryLogList extends React.Component<Props, {}> {
  render() {
    return (
      <ul className='list-group'>
        {this.props.inventoryLogs.map((log) => {
          return (
            <li key={log.id} className='list-group-item'>
              <div className='d-flex'>
                <div style={{ flexGrow: 1 }}>
                  <div className='text-muted'>
                    <small>
                      {log.type} - {moment(log.createDate).format('LLLL')}
                    </small>
                  </div>
                  <div className='text-muted'>
                    <small>{log.userName}</small>
                  </div>
                  <div>{log.productName}</div>
                  {log.note !== undefined && (
                    <div className='text-muted gr-sales-notes'>{log.note}</div>
                  )}
                </div>
                <div className='text-right'>
                  <div style={{ fontSize: '1.5rem' }}>
                    {log.updateValue > 0 ? `+${log.updateValue}` : log.updateValue}
                  </div>
                  <small className='text-muted'>
                    {log.previousValue} {'>'} {log.newValue}
                  </small>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    )
  }
}
